import { Pipe, PipeTransform } from '@angular/core';
import {
    Activity,
    ActivityStatusType,
    ActivityType,
} from '@wdx/clmi/clmi-swagger-gen';
import { DisplayDatePipe } from '@wdx/shared/utils';
import { ActivityStatusDateOptions } from '../models/activity-status.model';

@Pipe({ name: 'activityStatusDate', standalone: false })
export class ActivityStatusDatePipe implements PipeTransform {
    transform(activity: Activity, opts?: ActivityStatusDateOptions): string {
        const defaultOptions = {
            labelPrefix: true,
            includeTime: false,
        };
        const options = {
            ...defaultOptions,
            ...opts,
        };

        return [
            ...(options.labelPrefix ? [this.getLabelPrefix(activity)] : []),
            new DisplayDatePipe().transform(this.getDate(activity), {
                todayAsString: true,
                includeTime: options.includeTime,
            }),
        ].join(' ');
    }

    getDate(activity: Activity) {
        if (
            activity.activityType !== ActivityType.Task &&
            activity.activityType !== ActivityType.WorkItem
        ) {
            return activity.due || activity.createdOn;
        }

        if (activity.status === ActivityStatusType.Complete) {
            return activity.completed || activity.createdOn;
        }

        return activity.due || activity.createdOn;
    }

    getLabelPrefix(activity: Activity) {
        switch (activity.activityType) {
            case ActivityType.Email:
                return 'Received';
            case ActivityType.Glia:
            case ActivityType.Qwil:
            case ActivityType.Sms:
            case ActivityType.SecureMessage:
                return '';
            case ActivityType.WorkItem:
            case ActivityType.Task:
                return activity.status === ActivityStatusType.Complete
                    ? ''
                    : 'Due';
            default:
                return activity.status === ActivityStatusType.Complete
                    ? ''
                    : 'Scheduled';
        }
    }
}
